export const getRecurlyHostedInvoiceUrl = ({
	invoiceId,
	token,
}: {
	invoiceId: string;
	token: string;
}) =>
	`https://${process.env.RECURLY_SUBDOMAIN}.recurly.com/account/invoices/${invoiceId}?ht=${token}`;
